/**
 * Monthlees advertorial listicle LP — plan select, multi-add, sticky, scroll depth.
 */
(function () {
  'use strict';

  var ROOT = '[data-monthlees-advertorial]';
  var SUBMITTING = 'data-adv-submitting';

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function track(eventName, props) {
    if (window.MonthleesAnalytics && typeof window.MonthleesAnalytics.track === 'function') {
      window.MonthleesAnalytics.track(eventName, props || {});
    }
  }

  function rootMeta(root) {
    return {
      funnel_lp: root.getAttribute('data-funnel-lp') || '',
      funnel_type: root.getAttribute('data-funnel-type') || '',
      angle: root.getAttribute('data-angle') || '',
      member_state: root.getAttribute('data-member-state') || '',
      lp_page: root.getAttribute('data-lp-page') || '',
    };
  }

  function selectedPlan(form) {
    var radio = form.querySelector('[data-adv-plan-radio]:checked');
    if (!radio) return null;
    return {
      variantId: parseInt(radio.getAttribute('data-variant-id'), 10),
      quantity: parseInt(radio.getAttribute('data-quantity'), 10) || 1,
      sellingPlanId: radio.getAttribute('data-selling-plan-id') || '',
      offerPlan: radio.getAttribute('data-offer-plan') || '',
      label: radio.getAttribute('data-plan-label') || '',
      visibleTo: radio.getAttribute('data-visible-to') || 'all',
      attachMembership: radio.getAttribute('data-attach-membership') === 'true',
      displayCents: parseInt(radio.getAttribute('data-display-cents'), 10) || 0,
      isMemberOffer: radio.getAttribute('data-is-member-offer') === 'true',
    };
  }

  function formatMoneyCents(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      }).format(value);
    } catch (e) {
      return '$' + value.toFixed(2);
    }
  }

  function readVariantPriceMap(buyboxShell) {
    var node = buyboxShell && buyboxShell.querySelector('[data-adv-variant-price-map]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function applyFlavourToPlans(root, buyboxShell) {
    var flavour = buyboxShell.querySelector('[data-adv-flavour-radio]:checked');
    if (!flavour) return;
    var variantId = flavour.getAttribute('data-variant-id');
    var priceMap = readVariantPriceMap(buyboxShell);
    var entry = priceMap && priceMap[variantId] ? priceMap[variantId] : null;
    var guestCents = entry
      ? entry.guestCents
      : parseInt(flavour.getAttribute('data-guest-cents'), 10) || 0;
    var memberCents = entry
      ? entry.memberCents
      : parseInt(flavour.getAttribute('data-member-cents'), 10) || 0;

    $all('[data-adv-plan-radio]', buyboxShell).forEach(function (radio) {
      radio.setAttribute('data-variant-id', variantId);
      var qty = parseInt(radio.getAttribute('data-quantity'), 10) || 1;
      var isMemberOffer = radio.getAttribute('data-is-member-offer') === 'true';
      var priceOverride = radio.getAttribute('data-price-override');
      if (priceOverride || radio.getAttribute('data-is-trial-offer') === 'true') {
        radio.setAttribute('data-display-cents', '0');
        var trialPlanLabel = radio.closest('.monthlees-advertorial__plan');
        var trialPriceNode = trialPlanLabel
          ? trialPlanLabel.querySelector('[data-adv-plan-display-price]')
          : null;
        if (trialPriceNode) {
          trialPriceNode.setAttribute('data-variant-id', variantId);
          trialPriceNode.textContent = priceOverride || '$0 today';
        }
        return;
      }
      var displayCents = guestCents;
      if (isMemberOffer && memberCents > 0) {
        displayCents = Math.round((memberCents * 90) / 100);
      } else if (radio.getAttribute('data-selling-plan-id') && !isMemberOffer) {
        displayCents = Math.round((guestCents * 90) / 100);
      }
      displayCents = displayCents * qty;
      radio.setAttribute('data-display-cents', String(displayCents));

      var planLabel = radio.closest('.monthlees-advertorial__plan');
      if (!planLabel) return;
      var priceNode = planLabel.querySelector('[data-adv-plan-display-price]');
      if (priceNode) {
        priceNode.setAttribute('data-variant-id', variantId);
        if (isMemberOffer) {
          priceNode.setAttribute('data-member-cents', String(memberCents));
          priceNode.setAttribute('data-member-subscribe-cents', String(displayCents));
        } else {
          priceNode.setAttribute('data-guest-cents', String(guestCents));
        }
        priceNode.textContent = formatMoneyCents(displayCents);
      }
      var compareNode = planLabel.querySelector('.monthlees-advertorial__plan-price--compare');
      if (compareNode && isMemberOffer && guestCents > 0) {
        compareNode.textContent = formatMoneyCents(guestCents * qty);
      }
    });

    $all('[data-bold-price-target="guest"]', buyboxShell).forEach(function (node) {
      if (node.closest('.monthlees-advertorial__plan')) return;
      node.setAttribute('data-variant-id', variantId);
      if (guestCents) node.setAttribute('data-guest-cents', String(guestCents));
    });
    $all('[data-bold-price-target="member"]', buyboxShell).forEach(function (node) {
      if (!node.closest('.monthlees-advertorial__plan')) {
        node.setAttribute('data-variant-id', variantId);
        if (memberCents) node.setAttribute('data-member-cents', String(memberCents));
      }
    });
  }

  function buildCartItems(root, plan) {
    var meta = rootMeta(root);
    var props = {
      _funnel_lp: meta.funnel_lp,
      _funnel_type: meta.funnel_type,
      _angle: meta.angle,
      _offer_plan: plan.offerPlan,
      _lp_page: meta.lp_page,
    };

    var items = [
      {
        id: plan.variantId,
        quantity: plan.quantity,
        properties: props,
      },
    ];

    if (plan.sellingPlanId) {
      items[0].selling_plan = plan.sellingPlanId;
    }

    var attach = root.getAttribute('data-membership-attach');
    var memberState = meta.member_state;
    var monthlyVariant = root.getAttribute('data-membership-monthly-variant-id');
    var monthlyPlan = root.getAttribute('data-membership-monthly-plan-id');

    // Guest/logged-in Member Subscribe & Save: product + Member Access Monthly.
    // Only when the selected plan opts in via data-attach-membership (not guest OT).
    var shouldAttach =
      plan.attachMembership === true &&
      attach === 'offer' &&
      (memberState === 'guest' || memberState === 'logged_in') &&
      monthlyVariant &&
      monthlyPlan;

    if (shouldAttach) {
      items.push({
        id: parseInt(monthlyVariant, 10),
        quantity: 1,
        selling_plan: parseInt(monthlyPlan, 10) || monthlyPlan,
        properties: {
          _membership_attached_by: meta.funnel_lp,
          _membership_plan: root.getAttribute('data-membership-plan-key') || 'basic_monthly',
        },
      });
    }

    return items;
  }

  function setError(form, message) {
    var el = form.querySelector('[data-adv-buybox-error]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function disableForm(form, disabled) {
    var btn = form.querySelector('[data-adv-buybox-submit]');
    if (btn) btn.disabled = disabled;
    if (disabled) {
      form.setAttribute(SUBMITTING, 'true');
    } else {
      form.removeAttribute(SUBMITTING);
    }
  }

  function addToCart(root, form, plan) {
    if (form.getAttribute(SUBMITTING) === 'true') return Promise.resolve();
    disableForm(form, true);
    setError(form, '');

    var items = buildCartItems(root, plan);
    var meta = rootMeta(root);

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            throw new Error((body && body.description) || (body && body.message) || 'Could not add to cart');
          }
          return body;
        });
      })
      .then(function () {
        track('lp_add_to_cart', meta);
        if (items.length > 1) {
          track('lp_membership_attached', meta);
        }
        if (window.MonthleesCartDrawer && typeof window.MonthleesCartDrawer.open === 'function') {
          window.MonthleesCartDrawer.open();
        }
        document.dispatchEvent(new CustomEvent('monthlees:cart-updated'));
      })
      .catch(function (err) {
        setError(form, err.message || 'Could not add to cart');
      })
      .finally(function () {
        disableForm(form, false);
      });
  }

  function updatePlanSelection(form) {
    $all('.monthlees-advertorial__plan', form).forEach(function (label) {
      var input = label.querySelector('[data-adv-plan-radio]');
      label.classList.toggle('monthlees-advertorial__plan--selected', !!(input && input.checked));
    });

    var fallbackVariant = form.querySelector('[data-adv-fallback-variant]');
    var fallbackPlan = form.querySelector('[data-adv-fallback-plan]');
    var plan = selectedPlan(form);
    if (plan && fallbackVariant) {
      fallbackVariant.value = plan.variantId;
    }
    if (fallbackPlan) {
      if (plan && plan.sellingPlanId) {
        fallbackPlan.value = plan.sellingPlanId;
        fallbackPlan.disabled = false;
      } else if (fallbackPlan) {
        fallbackPlan.disabled = true;
      }
    }
  }

  function syncSticky(root) {
    var sticky = root.querySelector('[data-adv-sticky]');
    if (!sticky || root.getAttribute('data-sticky-enabled') !== 'true') return;

    var closing = root.querySelector('[data-adv-buybox-position="closing"]');
    if (!closing) return;

    var form = closing.querySelector('[data-adv-buybox-form]');
    var plan = form ? selectedPlan(form) : null;
    var priceEl = sticky.querySelector('[data-adv-sticky-price]');
    var btn = sticky.querySelector('[data-adv-sticky-submit]');

    if (plan && form) {
      var checked = form.querySelector('[data-adv-plan-radio]:checked');
      var priceNode = checked
        ? checked.closest('.monthlees-advertorial__plan').querySelector('[data-adv-plan-display-price]')
        : null;
      if (priceEl && priceNode) {
        priceEl.textContent = priceNode.textContent.trim();
        priceEl.hidden = false;
      }
      if (btn && plan.label) {
        var stickyLabel = 'Add — ' + plan.label;
        var labelSpan = btn.querySelector('span');
        if (labelSpan) {
          labelSpan.textContent = stickyLabel;
        } else {
          btn.textContent = stickyLabel;
        }
      }
    }
  }

  function initPlanGroups(root) {
    $all('[data-adv-buybox-form]', root).forEach(function (form) {
      var buyboxShell = form.closest('[data-adv-buybox-shell]') || form.closest('[data-adv-buybox]');

      form.addEventListener('submit', function (evt) {
        if (window.fetch) {
          evt.preventDefault();
          var plan = selectedPlan(form);
          if (!plan || !plan.variantId) return;
          addToCart(root, form, plan);
        }
      });

      $all('[data-adv-plan-radio]', form).forEach(function (radio) {
        radio.addEventListener('change', function () {
          updatePlanSelection(form);
          syncSticky(root);
          track('lp_plan_select', Object.assign({}, rootMeta(root), {
            offer_plan: radio.getAttribute('data-offer-plan') || '',
          }));
        });
      });

      $all('[data-adv-flavour-radio]', buyboxShell || root).forEach(function (radio) {
        radio.addEventListener('change', function () {
          applyFlavourToPlans(root, buyboxShell || root);
          updatePlanSelection(form);
          syncSticky(root);
        });
      });

      if (buyboxShell && buyboxShell.querySelector('[data-adv-flavour-radio]')) {
        applyFlavourToPlans(root, buyboxShell);
      }
      updatePlanSelection(form);
    });
  }

  function initBrandbar(root) {
    var bar = root.querySelector('[data-adv-brandbar]');
    if (!bar) return;

    var threshold = 72;
    var ticking = false;

    function update() {
      ticking = false;
      var show = window.scrollY > threshold;
      bar.toggleAttribute('data-adv-brandbar-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-adv-sticky]');
    if (!sticky || root.getAttribute('data-sticky-enabled') !== 'true') return;

    var closing = root.querySelector('[data-adv-buybox-position="closing"]');
    var compliance = root.querySelector('[data-adv-compliance]:not(.monthlees-advertorial__compliance--condensed)');

    var showSticky = false;
    var observer;

    function setStickyVisible(visible) {
      sticky.hidden = !visible;
      sticky.toggleAttribute('data-adv-sticky-visible', visible);
    }

    if ('IntersectionObserver' in window && closing) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            showSticky = !entry.isIntersecting && window.scrollY > 200;
            setStickyVisible(showSticky);
          });
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -20% 0px' }
      );
      observer.observe(closing);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          setStickyVisible(window.scrollY > 400);
        },
        { passive: true }
      );
    }

    if (compliance && 'IntersectionObserver' in window) {
      var complianceObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && showSticky) {
              setStickyVisible(false);
            }
          });
        },
        { threshold: 0.1 }
      );
      complianceObserver.observe(compliance);
    }

    sticky.querySelector('[data-adv-sticky-submit]').addEventListener('click', function () {
      if (sticky.getAttribute(SUBMITTING) === 'true') return;
      var closingForm = closing && closing.querySelector('[data-adv-buybox-form]');
      if (!closingForm) return;
      var plan = selectedPlan(closingForm);
      if (!plan) return;
      sticky.setAttribute(SUBMITTING, 'true');
      addToCart(root, closingForm, plan).finally(function () {
        sticky.removeAttribute(SUBMITTING);
      });
    });

    syncSticky(root);
  }

  function initScrollDepth(root) {
    var meta = rootMeta(root);
    var marks = { 25: false, 50: false, 75: false, 100: false };

    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = Math.round((window.scrollY / scrollable) * 100);
      [25, 50, 75, 100].forEach(function (mark) {
        if (!marks[mark] && pct >= mark) {
          marks[mark] = true;
          track('lp_scroll_' + mark, meta);
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initReasonViews(root) {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var meta = rootMeta(root);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = entry.target.getAttribute('data-adv-reason-index');
          if (!idx || seen[idx]) return;
          seen[idx] = true;
          track('lp_reason_view', Object.assign({}, meta, { reason_index: parseInt(idx, 10) }));
        });
      },
      { threshold: 0.35 }
    );

    $all('[data-adv-reason]', root).forEach(function (node) {
      observer.observe(node);
    });
  }

  function initBuyboxViews(root) {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var meta = rootMeta(root);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var pos = entry.target.getAttribute('data-adv-buybox-position') || 'closing';
          var idx = entry.target.getAttribute('data-adv-buybox-index') || '';
          var key = pos + idx;
          if (seen[key]) return;
          seen[key] = true;
          track('lp_buybox_view', Object.assign({}, meta, {
            position: pos,
            position_index: idx ? parseInt(idx, 10) : null,
          }));
        });
      },
      { threshold: 0.25 }
    );

    $all('[data-adv-buybox]', root).forEach(function (node) {
      observer.observe(node);
    });
  }

  function setShellError(shell, message) {
    if (!shell) return;
    var el = shell.querySelector('[data-adv-buybox-error]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function postCartItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          throw new Error((body && body.description) || (body && body.message) || 'Could not add to cart');
        }
        return body;
      });
    });
  }

  function openCartDrawer() {
    if (window.MonthleesCartDrawer && typeof window.MonthleesCartDrawer.open === 'function') {
      window.MonthleesCartDrawer.open();
    }
    document.dispatchEvent(new CustomEvent('monthlees:cart-updated'));
  }

  function initCollectionAdds(root) {
    var meta = rootMeta(root);

    $all('[data-adv-collection-add]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute(SUBMITTING) === 'true') return;
        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        var shell = btn.closest('[data-adv-buybox-shell]') || btn.closest('[data-adv-buybox]');
        setShellError(shell, '');
        btn.setAttribute(SUBMITTING, 'true');
        btn.disabled = true;

        postCartItems([
          {
            id: variantId,
            quantity: 1,
            properties: {
              _funnel_lp: meta.funnel_lp,
              _funnel_type: meta.funnel_type,
              _angle: meta.angle,
              _offer_plan: 'collection-single',
              _lp_page: meta.lp_page,
            },
          },
        ])
          .then(function () {
            track('lp_add_to_cart', Object.assign({}, meta, {
              offer_plan: 'collection-single',
              product_title: btn.getAttribute('data-product-title') || '',
            }));
            openCartDrawer();
          })
          .catch(function (err) {
            setShellError(shell, err.message || 'Could not add to cart');
          })
          .finally(function () {
            btn.removeAttribute(SUBMITTING);
            btn.disabled = false;
          });
      });
    });
  }

  function resolveProtocolLines(rawLines) {
    var lines = [];
    if (!rawLines) return lines;
    var parsed = rawLines;
    if (typeof rawLines === 'string') {
      try {
        parsed = JSON.parse(rawLines);
      } catch (e) {
        return lines;
      }
    }
    if (!Array.isArray(parsed)) return lines;

    parsed.forEach(function (line) {
      if (!line) return;
      var variantId = parseInt(line.variant_id || line.variantId || line.id, 10);
      var handle = line.product_handle || line.handle || '';
      var qty = parseInt(line.quantity, 10) || 1;
      if (!variantId && handle && window.meta && window.meta.product) {
        // no catalogue lookup available client-side without a map
      }
      if (variantId) {
        lines.push({
          id: variantId,
          quantity: qty,
          handle: handle,
          title: line.title || handle || String(variantId),
        });
      }
    });
    return lines;
  }

  function initProtocolAdd(root) {
    var meta = rootMeta(root);

    $all('[data-adv-protocol-add]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute(SUBMITTING) === 'true') return;
        var shell = btn.closest('[data-adv-buybox-shell]') || btn.closest('[data-adv-buybox]');
        setShellError(shell, '');

        var lines = resolveProtocolLines(btn.getAttribute('data-adv-protocol-lines'));
        if (!lines.length) {
          setShellError(shell, 'Protocol items are unavailable.');
          return;
        }

        var items = lines.map(function (line) {
          return {
            id: line.id,
            quantity: line.quantity,
            properties: {
              _funnel_lp: meta.funnel_lp,
              _funnel_type: meta.funnel_type,
              _angle: meta.angle,
              _offer_plan: btn.getAttribute('data-offer-plan') || 'protocol-bundle',
              _lp_page: meta.lp_page,
            },
          };
        });

        btn.setAttribute(SUBMITTING, 'true');
        btn.disabled = true;

        // Try full protocol first; on failure, add available lines one-by-one and report skips.
        postCartItems(items)
          .then(function () {
            track('lp_add_to_cart', Object.assign({}, meta, {
              offer_plan: btn.getAttribute('data-offer-plan') || 'protocol-bundle',
              line_count: items.length,
            }));
            openCartDrawer();
          })
          .catch(function () {
            var added = [];
            var skipped = [];
            var chain = Promise.resolve();

            lines.forEach(function (line) {
              chain = chain.then(function () {
                return postCartItems([
                  {
                    id: line.id,
                    quantity: line.quantity,
                    properties: {
                      _funnel_lp: meta.funnel_lp,
                      _funnel_type: meta.funnel_type,
                      _angle: meta.angle,
                      _offer_plan: btn.getAttribute('data-offer-plan') || 'protocol-bundle',
                      _lp_page: meta.lp_page,
                    },
                  },
                ])
                  .then(function () {
                    added.push(line.title);
                  })
                  .catch(function () {
                    skipped.push(line.title);
                  });
              });
            });

            return chain.then(function () {
              if (added.length) {
                track('lp_add_to_cart', Object.assign({}, meta, {
                  offer_plan: btn.getAttribute('data-offer-plan') || 'protocol-bundle',
                  line_count: added.length,
                  skipped_count: skipped.length,
                }));
                openCartDrawer();
              }
              if (skipped.length) {
                setShellError(
                  shell,
                  'Added ' +
                    added.length +
                    ' item(s). Skipped unavailable: ' +
                    skipped.join(', ') +
                    '.'
                );
              } else if (!added.length) {
                setShellError(shell, 'Could not add protocol items to cart.');
              }
            });
          })
          .finally(function () {
            btn.removeAttribute(SUBMITTING);
            btn.disabled = false;
          });
      });
    });
  }

  function initKeyboardNav(root) {
    $all('[data-adv-plan-group]', root).forEach(function (group) {
      group.addEventListener('keydown', function (evt) {
        var radios = $all('[data-adv-plan-radio]:not(:disabled)', group);
        var idx = radios.findIndex(function (r) {
          return r === document.activeElement;
        });
        if (idx < 0) return;
        var next = idx;
        if (evt.key === 'ArrowDown' || evt.key === 'ArrowRight') next = (idx + 1) % radios.length;
        if (evt.key === 'ArrowUp' || evt.key === 'ArrowLeft') next = (idx - 1 + radios.length) % radios.length;
        if (next !== idx) {
          evt.preventDefault();
          radios[next].focus();
          radios[next].checked = true;
          radios[next].dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function initGallery(root) {
    $all('[data-adv-gallery]', root).forEach(function (gallery) {
      var main = gallery.querySelector('[data-adv-gallery-main], .monthlees-advertorial__buybox-image');
      if (!main) return;

      $all('[data-adv-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-adv-gallery-src');
          var srcset = thumb.getAttribute('data-adv-gallery-srcset');
          var alt = thumb.getAttribute('data-adv-gallery-alt') || '';
          if (!src) return;
          main.src = src;
          if (srcset) main.srcset = srcset;
          main.alt = alt;
          $all('[data-adv-gallery-thumb]', gallery).forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
            t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  function reviveScripts(container) {
    $all('script', container).forEach(function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes || [], function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function initAitReviews(root) {
    $all('[data-adv-reviews-app][data-product-handle]', root).forEach(function (slot) {
      if (slot.getAttribute('data-ait-bound') === 'true') return;
      slot.setAttribute('data-ait-bound', 'true');

      var handle = slot.getAttribute('data-product-handle');
      var view = slot.getAttribute('data-ait-reviews-view') || 'ait-reviews-embed';
      var mount = slot.querySelector('[data-adv-reviews-mount]') || slot;
      if (!handle) {
        slot.setAttribute('aria-busy', 'false');
        return;
      }

      var url = '/products/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(view);
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Reviews embed request failed');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var embed = doc.querySelector('[data-monthlees-ait-reviews]');
          if (!embed) throw new Error('Reviews embed root missing');
          mount.innerHTML = '';
          while (embed.firstChild) {
            mount.appendChild(embed.firstChild);
          }
          reviveScripts(mount);
          slot.setAttribute('aria-busy', 'false');
        })
        .catch(function () {
          mount.innerHTML =
            '<p class="monthlees-advertorial__reviews-app-loading">Reviews unavailable right now.</p>';
          slot.setAttribute('aria-busy', 'false');
        });
    });
  }

  function initRoot(root) {
    track('lp_view', rootMeta(root));
    initPlanGroups(root);
    initGallery(root);
    initBrandbar(root);
    initSticky(root);
    initScrollDepth(root);
    initReasonViews(root);
    initBuyboxViews(root);
    initCollectionAdds(root);
    initProtocolAdd(root);
    initKeyboardNav(root);
    initAitReviews(root);
  }

  function init() {
    $all(ROOT).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
